import { createAsyncThunk } from '@reduxjs/toolkit';
import END_POINTS from '../../../../services/endpoints';
import apiVRR from '../../../../libs/axios/apis';
import { notify } from '../../../app/appSlice';
import { TTagList } from '../../../../micro_front_end/creative_analytics/creative_video_gallery/creative_tag_modal/types';

export const fetchRootGallery = createAsyncThunk(
  'creativeGallery/fetchRootGallery',
  async (currentBrandId: string) => {
    const endpointURL =
      END_POINTS.CREATIVE_ANALYTICS.CREATIVE_GALLERY.ROOT_GALLERY(
        currentBrandId
      );
    const response = await apiVRR('v2').get(endpointURL);

    return response.data;
  }
);

export const fetchFolder = createAsyncThunk(
  'creativeGallery/fetchFolder',
  async (folderId: string, { getState }) => {
    const currentState = getState() as any;
    const currentBrandId =
      currentState.setting.vrr_preferences.current_brand_id;
    const endpoint =
      END_POINTS.CREATIVE_ANALYTICS.CREATIVE_GALLERY.FOLDER_DETAILS(
        currentBrandId,
        folderId
      );

    const response = await apiVRR('v2').get(endpoint);

    return response.data;
  }
);

export const moveVideo = createAsyncThunk(
  'creativeGallery/moveVideo',
  async (
    params: { folderDestination: number; videos?: Array<number> },
    { getState }
  ) => {
    const currentState = getState() as any;
    const currentBrandId =
      currentState.setting.vrr_preferences.current_brand_id;
    let lastResponse = undefined;
    params.videos?.forEach((video, index) => {
      const endpoint =
        END_POINTS.CREATIVE_ANALYTICS.CREATIVE_GALLERY.MOVE_VIDEO(
          currentBrandId,
          video.toString()
        );

      const response = apiVRR('v2').put(endpoint, {
        parent_id: params.folderDestination
      });

      if (params.videos?.length === index + 1) {
        lastResponse = response;
      }
    });

    return lastResponse;
  }
);

export const addFolder = createAsyncThunk(
  'creativeGallery/addFolder',
  async (
    params: {
      name: string;
      videos: number[];
    },
    { dispatch, getState }
  ) => {
    const currentState = getState() as any;
    const currentBrandId =
      currentState.setting.vrr_preferences.current_brand_id;
    const rootId = currentState.creativeGallery.rootId;
    const endpointURL =
      END_POINTS.CREATIVE_ANALYTICS.CREATIVE_GALLERY.NEW_FOLDER(currentBrandId);

    const response = await apiVRR('v2').post(endpointURL, {
      parentId: rootId,
      name: params.name,
      videos: params.videos
    });

    if (response.status >= 200) {
      dispatch(notify({ type: 'success' }));
    }

    return response.data;
  }
);

export const updateFolder = createAsyncThunk(
  'creativeGallery/updateFolder',
  async (
    params: {
      id: number;
      name: string;
    },
    { dispatch, getState }
  ) => {
    const currentAccountId = (getState() as any).setting.vrr_preferences
      .current_brand_id;
    const endpoint =
      END_POINTS.CREATIVE_ANALYTICS.CREATIVE_GALLERY.FOLDER_DETAILS(
        currentAccountId,
        params.id.toString()
      );

    const response = await apiVRR('v2').put(endpoint, params);

    if (response.status >= 200) {
      dispatch(notify({ type: 'success' }));
    }

    return response.data;
  }
);

export const archive = createAsyncThunk(
  'creativeGallery/archive',
  async (
    params: {
      data: {
        folderId: number;
        videosIds: number[];
        foldersIds: number[];
      };
    },
    { dispatch, getState }
  ) => {
    const currentState = getState() as any;
    const currentBrandId =
      currentState.setting.vrr_preferences.current_brand_id;
    const endpoint = END_POINTS.CREATIVE_ANALYTICS.CREATIVE_GALLERY.ARCHIVE(
      currentBrandId.toString()
    );

    const response = await apiVRR('v2').delete(endpoint, params);

    if (response.status >= 200) {
      dispatch(notify({ type: 'success' }));
    }

    return response.data;
  }
);

export const fetchVideoById = createAsyncThunk(
  'creativeGallery/fetchVideoById',
  async (videoIds: number[], { getState }) => {
    const currentState = getState() as any;
    const currentBrandId =
      currentState.setting.vrr_preferences.current_brand_id;
    const endPoint =
      END_POINTS.CREATIVE_ANALYTICS.CREATIVE.ALL_VIDEOS(currentBrandId);

    const response = await apiVRR('v2').get(endPoint, {
      params: { video_ids: videoIds.join(',') }
    });

    return response.data;
  }
);

export const fetchAllTags = createAsyncThunk(
  'creativeGallery/fetchAllTags',
  async (_, { getState }) => {
    const currentState = getState() as any;
    const currentBrandId =
      currentState.setting.vrr_preferences.current_brand_id;
    const endPoint =
      END_POINTS.CREATIVE_ANALYTICS.CREATIVE.TAGS(currentBrandId);

    const response = await apiVRR('v2').get(endPoint);

    return response.data;
  }
);

export const updateTags = createAsyncThunk(
  'creativeGallery/updateTags',
  async (videos: TTagList[], { dispatch, getState }) => {
    const currentState = getState() as any;
    const currentBrandId =
      currentState.setting.vrr_preferences.current_brand_id;
    const endPoint =
      END_POINTS.CREATIVE_ANALYTICS.CREATIVE.VIDEOS_TAGS(currentBrandId);

    const response = await apiVRR('v2').put(endPoint, {
      videos
    });

    if (response.status >= 200 && response.status < 400) {
      dispatch(notify({ type: 'success' }));
    }

    return response.data;
  }
);
